import { listNewsIndex_filedMirgrants } from '@/components/widgets/list_news_index/fieldMirgrants.js'
import { buttonIcon_filedMirgrants } from '@/components/widgets/button_icon/fieldMirgrants.js'
import { listProduct_filedMirgrants } from '@/components/widgets/list_product/fieldMirgrants.js'
import { listCase_filedMirgrants } from '@/components/widgets/list_case/fieldMirgrants.js'
import { listDownload_filedMirgrants } from '@/components/widgets/list_download/fieldMirgrants.js'
import { textTitle_filedMirgrants } from '@/components/widgets/text_title/fieldMirgrants.js'
import { expandCollapse_filedMirgrants } from '@/components/widgets/expand_collapse_tags/fieldMirgrants.js'

import { homeProductlist_filedMirgrants } from '@/components/widgets/home_product_list/fieldMirgrants.js'

import { button_filedMirgrants } from '@/components/widgets/button_text_icon/fieldMirgrants.js'

//字段迁移
export function filedMirgrants(node) {
  if (node.data) {
    if (node.componentName === 'button_icon') {
      node = buttonIcon_filedMirgrants(node)
    }
    if (node.componentName === 'list_news_index') {
      node = listNewsIndex_filedMirgrants(node)
    }
    if (node.componentName === 'home_product_list') {
      node = homeProductlist_filedMirgrants(node)
    } else if (node.componentName === 'list_product') {
      node = listProduct_filedMirgrants(node)
    } else if (node.componentName === 'list_case') {
      node = listCase_filedMirgrants(node)
    } else if (node.componentName === 'list_download') {
      node = listDownload_filedMirgrants(node)
    } else if (node.componentName === 'text_title') {
      node = textTitle_filedMirgrants(node)
    } else if (node.componentName === 'expand_collapse_tags') {
      node = expandCollapse_filedMirgrants(node)
    } else if (node.componentName === 'button_text_icon'){
      node = button_filedMirgrants(node)
    }
  }

  return node
}
